import { ActionButtonProps, Box, Form, TextNew } from '@jfs/ui-new'
import { useNavigation, useRoute } from '@react-navigation/core'
import { FC, useCallback, useEffect, useRef, useState } from 'react'
import { ScrollView } from 'react-native'
import { Routes } from '../../../../../src/nav/routes'
import { useLazyApiData, useStores } from '../../../../data/store'
import styles from '../../styles'
import { addNewSettlementReportForm } from './formData'
import { updateBasedOnFileTransferMode, updatePayload } from './helper'
import { getReportExtensions } from './ReportFrequency'
import SubmitUpdateButton from './SubmitUpdateButton'

const AddNewSettlementReport: FC = ({ route }: any) => {
  const {
    addNewSettlementReportApi,
    mid,
    updateSettlementReportFormat,
    downloadSampleReportFormat,
    getSettlementReportById,
  } = useStores((store) => ({
    merchantName: store.settings.metaData.selectedMercName,
    addNewSettlementReportApi: store.settlements.addNewSettlementReportApi,
    mid: store.user.selectedMid,
    updateSettlementReportFormat: store.settlements.updateSettlementReportFormat,
    downloadSampleReportFormat: store.settlements.downloadSampleReportFormat,
    getSettlementReportById: store.settlements.getSettlementReportById,
  }))
  const themes = styles(0)
  const path = useRoute().name
  const navigation = useNavigation()
  const formRef = useRef(null)
  const itemData = useRef({})
  const isUpdate = route?.params?.data ? true : false
  const isNewPassword: any = useRef({})
  const formActionButtonRef = useRef<ActionButtonProps>()

  const [isLoading, toggleLoader] = useState(false)
  const [fileTransferMode, setFileTransferMode] = useState('')
  const [reportExtensions, setReportExtensions] = useState(getReportExtensions())

  const { response } = useStores((store) => ({
    response: store.response,
  }))

  const onFormSubmit = useCallback(() => {
    formActionButtonRef?.current?.onPress()
  }, [])

  const [updateSettlementReport, updateSettlementReportHandler] = useLazyApiData(updateSettlementReportFormat)
  const [addSettlementReportFormat, addSettlementReportFormatHandler] = useLazyApiData(addNewSettlementReportApi)

  const onSubmitClicked = () => {
    //console.log('onSubmitClicked formActionButtonRef.current', formActionButtonRef.current)
    if (formActionButtonRef.current?.isCurrentFormValid) {
      const values: any = formActionButtonRef.current.values
      if (isUpdate) {
        toggleLoader(true)
        const payload = updatePayload({
          values,
          m_id: mid,
          isUpdate,
          getReportData,
          isNewPassword: isNewPassword.current,
          response,
        })
        // console.log('update-', isUpdate)
        // console.log('isNewPassword-', isNewPassword.current)
        //console.log('update payload-', payload)
        isNewPassword.current = isNewPassword.current
        payload && updateSettlementReport(itemData?.current?.id, mid, payload)
        toggleLoader(false)
      } else {
        toggleLoader(true)
        const payload = updatePayload({
          values,
          m_id: mid,
          getReportData,
          isNewPassword: isNewPassword.current,
          response,
        })
        //console.log('create payload', isNewPassword.current, payload)
        payload && addSettlementReportFormat(mid, payload)
        toggleLoader(false)
      }
    } else {
      response?.setBgColor('RED')
      response?.setMessage('Please enter all the mandatory fields')
    }
  }

  useEffect(() => {
    if (
      updateSettlementReportHandler?.state === 'fulfilled' ||
      addSettlementReportFormatHandler?.state === 'fulfilled'
    ) {
      toggleLoader(false)
      setTimeout(() => {
        navigation.navigate(Routes.SETTLEMENTS_REPORTING as never)
      }, 800)
    } else if (
      updateSettlementReportHandler?.state === 'rejected' ||
      addSettlementReportFormatHandler?.state === 'rejected'
    ) {
      toggleLoader(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addSettlementReportFormatHandler.state, updateSettlementReportHandler.state])

  let getReportData: any = getSettlementReportById(route?.params?.data)

  if (getReportData && isUpdate) {
    updateBasedOnFileTransferMode({
      mode: getReportData?.fileTransferMode,
      getReportData: getReportData,
      itemData: itemData,
    })
  }

  const renderActionButton = (props: ActionButtonProps) => {
    formActionButtonRef.current = props
    return <></>
  }

  const handleDownloadSample = (reportingFormat, reportingType) => {
    downloadSampleReportFormat(reportingFormat, reportingType)
  }

  const setIsNewPassword = useCallback((key, value) => {
    isNewPassword.current[key] = value
  }, [])

  return (
    <ScrollView contentContainerStyle={themes.scrollContainer}>
      <Box {...themes[path].container} borderWidth={12}>
        <Box
          {...themes.stickyHeader}
          borderBottomWidth={1}
          pb={15}
          borderColor={'DISABLED_GREY'}
          flexDirection={'row'}
          justifyContent={'space-between'}>
          <Box justify="center">
            <TextNew
              {...themes.titleText}
              title={isUpdate ? 'Settlement Report Configuration' : '+ Add New Report Configuration'}
            />
          </Box>
          <SubmitUpdateButton
            {...formActionButtonRef.current}
            isUpdate={isUpdate}
            onProceedPress={onSubmitClicked}
            isLoading={isLoading}
            onCancel={() => navigation.canGoBack() && navigation.goBack()}
          />
        </Box>
        {/* <Box f={1} flexDirection={'row'}> */}
        <Box maxWidth={120} marginTop={72} marginLeft={'3%'}>
          <TextNew fontFamily="jiotype-bold" fontSize={14} color={'BLACK_21'} lineHeight={21}>
            {'Report Configuration'}
          </TextNew>
        </Box>
        <Box
          f={1}
          overflow="auto"
          width={'85%'}
          height={'140%'}
          marginTop={-72}
          justifyContent={'flex-start'}
          alignItems={'flex-start'}
          alignSelf={'flex-end'}
          // backgroundColor={'RED'}
          flexWrap="wrap">
          <Form
            ref={formRef}
            formData={
              addNewSettlementReportForm(
                handleDownloadSample,
                reportExtensions,
                setReportExtensions,
                isUpdate,
                isNewPassword.current,
                setIsNewPassword,
                setFileTransferMode,
                fileTransferMode,
              ) as never
            }
            actionButtons={renderActionButton}
            onFormSubmit={onFormSubmit}
            initialValues={itemData.current as any}
            container={({ children }) => <Box w={'88%'}>{children}</Box>}
          />
        </Box>
        {/* </Box> */}
      </Box>
    </ScrollView>
  )
}

export { AddNewSettlementReport as default }
